import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ModalService } from '../../modal/modal.service';
import { SupportMyTicketsModalComponent } from '../../modals/support-my-tickets-modal/support-my-tickets-modal.component';
import { NavigationService } from '@features/navigation/navigation.service';
import { IconComponent } from '@shared/icon/icon.component';

@Component({
  selector: 'app-top-bar-navigation',
  templateUrl: './top-bar-navigation.component.html',
  styleUrls: ['./top-bar-navigation.component.scss'],
  imports: [RouterLink, NgClass, IconComponent],
})
export class TopBarNavigationComponent {
  constructor(public navigationService: NavigationService, private modalService: ModalService) {}

  openSupportModal() {
    this.modalService.open(SupportMyTicketsModalComponent, null, { requiresAuth: true });
  }
}
